import React from "react";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
export default function IconAvailable() {
  return (
    <FiberManualRecordOutlinedIcon className="staff-icon staff-available" />
  );
}
